import { render, staticRenderFns } from "./RODO.vue?vue&type=template&id=79f29661&scoped=true&"
import script from "./RODO.vue?vue&type=script&lang=js&"
export * from "./RODO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f29661",
  null
  
)

export default component.exports